import { withParams } from "@/utils/route";

interface OrganizationRouteParams {
  slug?: string | string[];
}

interface ReservationRouteParams extends OrganizationRouteParams {
  employee?: string;
  date?: string;
}

interface ReservationDetailRouteParams extends OrganizationRouteParams {
  reservationId: string;
  email?: string;
  isWithConfirm?: boolean;
}

interface EmployeeReservationDetailRouteParams extends OrganizationRouteParams {
  employeeReservationId: string;
  email?: string;
  isWithConfirm?: boolean;
}
interface WaitingRoomRouteParams extends OrganizationRouteParams {
  date?: string;
}

interface NewPatientRouteParams {
  organizationSlug?: string | string[];
  employeeId: string;
}

interface AppointmentRouteParams {
  organizationSlug?: string | string[];
  appointmentId: string | string[];
  email?: string;
}

interface CalendarViewParams {
  date?: string;
  view?: string;
  employee?: string;
  appointment?: string;
  addEventStartAt?: string;
  addEventEndAt?: string;
  addEventType?: string;
  addEvent?: string;
}

export const PROFILE_MANAGER_TABS = {
  EMPLOYEES: "rady",
  SERVICES: "sluzby",
  TAGS: "skupiny",
  GENERAL_SETTINGS: "vseobecne-nastavenia",
  COMMON_INFO: "zakladne-udaje",
};

export const ROUTES = {
  PLATFORM_CONTACT: () => `/#kontakt`,
  PUBLIC_SERVICE_RESERVATION_PAGE: ({ id }: { id: string }) => {
    const params = withParams({});

    return `/p/${id}${params ? `?${params}` : ""}`;
  },
  HOME: "/",
  PROFILE_MANAGER: (params?: { tab?: string }) =>
    `/nastavenia${params && params.tab ? `?tab=${params.tab}` : ""}`,
  EMPLOYEE_MANAGER: ({ id }: { id: string }) => `/nastavenia/rad/${id}`,
  SERVICES_MANAGER: ({ id }: { id: string }) => `/nastavenia/sluzby/${id}`,
  TAGS_MANAGER: ({ id }: { id: string }) => `/nastavenia/skupiny/${id}`,
  ORGANIZATION: ({ slug }: OrganizationRouteParams) => `/organizacia/${slug}`,
  GET_SLOT: ({ slug }: OrganizationRouteParams) =>
    `/organizacia/${slug}/ziskat-termin`,
  RESERVATION_PAGE: ({ slug, employee, date }: ReservationRouteParams) => {
    const params = withParams({
      ...(employee ? { employee } : {}),
      ...(date ? { date } : {}),
    });
    return `/organizacia/${slug}/objednanie-na-cas${
      params ? `?${params}` : ""
    }`;
  },
  EMPLOYEE_RESERVATION_DETAIL: ({
    slug,
    employeeReservationId,
    email,
    isWithConfirm,
  }: EmployeeReservationDetailRouteParams) =>
    `/organizacia/${slug}/rezervacia-ambulancie/${employeeReservationId}${
      email
        ? `?${withParams({
            email,
            ...(isWithConfirm
              ? {
                  isWithConfirm: isWithConfirm.toString(),
                }
              : {}),
          })}`
        : ""
    }`,
  RESERVATION_DETAIL: ({
    slug,
    reservationId,
    email,
    isWithConfirm,
  }: ReservationDetailRouteParams) =>
    `/organizacia/${slug}/rezervacia/${reservationId}${
      email
        ? `?${withParams({
            email,
            ...(isWithConfirm
              ? {
                  isWithConfirm: isWithConfirm.toString(),
                }
              : {}),
          })}`
        : ""
    }`,
  WAITING_ROOM: ({ slug, date }: WaitingRoomRouteParams) =>
    `/organizacia/${slug}/cakaren${
      date ? `?${withParams({ selectedDate: date })}` : ""
    }`,
  SIGN_IN: () => "/prihlasenie",
  NEW_PATIENT: ({ organizationSlug, employeeId }: NewPatientRouteParams) =>
    `/organizacia/${organizationSlug}/novy-zaznam/${employeeId}`,
  APPOINTMENT_DETAIL: ({
    organizationSlug,
    appointmentId,
    email,
  }: AppointmentRouteParams) =>
    `/organizacia/${organizationSlug}/zaznam/${appointmentId}${
      email ? `?${withParams({ email })}` : ""
    }`,
  FORGOTTEN_PASSWORD: "/zmena-hesla",
  SIGN_UP_THANK_YOU: "/dakujeme",
  DASHBOARD_STATS: () => "/statistiky",
  DASHBOARD_NO_SHOW: ({
    email,
    from,
    to,
  }: { email?: string; from?: string; to?: string } = {}) => {
    const params = withParams({
      ...(email ? { email: encodeURIComponent(email) } : {}),
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
    });
    return `/neuskutocnene${params ? `?${params}` : ""}`;
  },
  DASHBOARD_CALENDAR: ({
    date,
    view,
    employee,
    appointment,
    addEventStartAt,
    addEventEndAt,
    addEventType,
    addEvent,
  }: CalendarViewParams = {}) =>
    `/kalendar?${withParams({
      ...(date ? { date } : {}),
      ...(view ? { view } : {}),
      ...(employee ? { employee } : {}),
      ...(appointment ? { appointment } : {}),
      ...(addEventStartAt ? { addEventStartAt } : {}),
      ...(addEventEndAt ? { addEventEndAt } : {}),
      ...(addEventType ? { addEventType } : {}),
      ...(addEvent ? { addEvent } : {}),
    })}`,
};
